import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Shared';
export const ForTeachers = () => {
  return <section className="py-24 bg-ivory relative border-t border-bronze/10" data-id="element-122">
      <div className="absolute inset-0 bg-noise pointer-events-none" data-id="element-123" />

      <div className="max-w-4xl mx-auto px-6 relative z-10 text-center" data-id="element-124">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-125">
          <div className="font-gurmukhi text-kesari/60 text-xl mb-4" data-id="element-126">ਉੱਦਮ</div>
          <h2 className="font-serif text-3xl md:text-4xl text-navy mb-6" data-id="element-127">
            Nominate a student with initiative.
          </h2>
          <p className="font-sans text-lg text-charcoal/70 mb-10 max-w-2xl mx-auto" data-id="element-128">
            Are you an educator or counsellor? We are looking for high school
            students who show raw potential, care about their community, and are
            ready for a challenge.
          </p>

          <div className="flex flex-col sm:flex-row justify-center gap-6 mb-10 text-left max-w-lg mx-auto" data-id="element-129">
            <ul className="space-y-3 font-sans text-sm text-charcoal/80" data-id="element-130">
              <motion.li whileHover={{
              x: 5
            }} className="flex items-center gap-2 transition-transform" data-id="element-131">
                <span className="text-kesari" data-id="element-132">✓</span> Strong work ethic
              </motion.li>
              <motion.li whileHover={{
              x: 5
            }} className="flex items-center gap-2 transition-transform" data-id="element-133">
                <span className="text-kesari" data-id="element-134">✓</span> Community-minded
              </motion.li>
            </ul>
            <ul className="space-y-3 font-sans text-sm text-charcoal/80" data-id="element-135">
              <motion.li whileHover={{
              x: 5
            }} className="flex items-center gap-2 transition-transform" data-id="element-136">
                <span className="text-kesari" data-id="element-137">✓</span> Willingness to learn
              </motion.li>
              <motion.li whileHover={{
              x: 5
            }} className="flex items-center gap-2 transition-transform" data-id="element-138">
                <span className="text-kesari" data-id="element-139">✓</span> Based in Brampton/GTA
              </motion.li>
            </ul>
          </div>

          <Button variant="outline" data-id="element-140">Nominate a Student</Button>
        </motion.div>
      </div>
    </section>;
};